import React from 'react';
import { Container } from 'reactstrap';
import Link from 'gatsby-link';
import SiteCollage from './site-collage.png';
import SensorMounting from './wintersense-csl-mounting-cropped.jpg';
import SensorCalibration from './sensor-calibration.jpg';



const TheSensor = () => (
  <div>

    <Container>

      <div className="mt-5">
        <p className="lead text-center">The Wintersense solution revolves around its sensor. Simply strap it a roadside lighting column for several years' worth of <span className="font-weight-bold">road surface temperature</span> measurements.</p>
      </div>

      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md">
            <h3>Deploy it virtually anywhere</h3>
            <p className="text-justify">Installing a traditional road weather outstation at every location of interest isn't always practical nor is it rarely affordable. The Wintersense sensor offers far greater freedom.</p>
            <p>This is thanks to the following features:</p>
            <ul>
              <li>Supports the Sigfox communication network and in combination with IoT platforms LTE, NB-IoT and LoRa networks, with coverage growing rapidly across the world.</li>
              <li>Requires almost no existing infrastruture. All that's needed is something to mount it to (e.g. a lighting column). Please see the <a href="https://docs.wintersense.com/installation/">Installation Guide</a> for further details.</li>
              <li>The sensor is completely self-contained with no external wiring to hook up. With enough battery capacity to last well over 1 year and possibilities to extend this to several years.</li>
            </ul>
          </div>
          <div className="col-md">
            <img src={SiteCollage} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section>


      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md order-md-2">
            <h3>Fast to install</h3>
            <p className="text-justify">A sensor that's faster to install not only saves on labour, but dense networks can be rolled out in a fraction of the time of traditional solutions. It's also easy to move sensors around your road network for further insights.</p>
            <p>Here's a few reasons why it's so quick:</p>
            <ul>
              <li>The road temperature sensor uses contactless passive infrared technology, therefore the road surface does not need cutting, saving on traffic disruption.</li>
              <li>The majority of LPWAN networks supported have national coverage, so there's no need to configure the sensor on site, it'll just connect straight out of the box.</li>
              <li>Mounting a sensor involves little more than tighting a stainless steel band and checking the sensor's alignment.</li>
              <li>The <a href="https://user.wintersense.com">Web Application</a> makes it easy to record new installation sites on the go from your smartphone.</li>
            </ul>
          </div>
          <div className="col-md order-md-1">
            <img src={SensorMounting} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section>      


      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md">
            <h3>Focused on accuracy</h3>
            <p className="text-justify">Affordable sensors need not be inaccurate.</p>
            <p>Wintersense takes several precautions to ensure accurate measurements:</p>
            <ul>
              <li>The Wintersense team has spent over 3 years testing, trialing, iterating and deploying its road temperature sensor to ensure they are fit for purpose.</li>
              <li>Wintersense has invested in a sophisticated climate chamber, capable of subjecting each sensor to freezing conditions to assess if it's accurate enough for deployment.</li>
              <li>As with any infrared road temperature sensor, vehicles can cause errors when they block the sensor's view of the road surface. Our software filters out any resulting temperature spikes.</li>
              <li>Once the sensor uploads it's data to the Wintersense cloud servers the data is passed through a variety of quality control checks to flag, and alert of, any suspect data. For more details see <Link to="/platform">The Platform</Link>.</li>
            </ul>
          </div>
          <div className="col-md">
            <img src={SensorCalibration} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section>

      <div className="mt-3">
        <p className="text-justify">For more details please see the <a href="https://www.campbellsci.eu/wintersense">specifications</a>.</p>
      </div>

    </Container>

    <br/>

  </div>
);

export default TheSensor;



// WEBPACK FOOTER //
// ./src/components/TheSensor/index.js